import { render } from "./ChannelSwitcher.vue?vue&type=template&id=2e784572"
import script from "./ChannelSwitcher.vue?vue&type=script&lang=js"
export * from "./ChannelSwitcher.vue?vue&type=script&lang=js"

import "./ChannelSwitcher.vue?vue&type=style&index=0&id=2e784572&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__